import { createAction } from 'redux-actions';

import { wrapFetch } from './endpoint';

export const getAttractions = createAction('FETCH_ATTRACTIONS', async (lan, hotel) => {
	const { status, message, data } = await wrapFetch(`api/v1/web/${lan}/${hotel}/attraction`, {
		method: 'GET',
	});

	if (status !== 200) {
		throw new Error(message);
	}

	const attractionList = [];
	const attractionData = {};

	data.forEach(d => {
		attractionList.push(d.id);
		attractionData[d.id] = {
			id: d.id,
			type: d.category,
			title: d.title,
			address: d.address,
			image: d.pic,
			thumbnail: d.pic_thumbnail,
			content: d.info,
			lat: parseFloat(d.latitude) || 0,
			lng: parseFloat(d.longitude) || 0,
			info: {
				locationName: d.title,
				address: d.address,
			},
		};
	});

	return {
		attractionList,
		attractionData,
	};
});

export const getEachHotelAttractions = createAction('FETCH_EACH_HOTEL_ATTRACTIONS', async lan => {
	const { status, message, data } = await wrapFetch(`api/v1/web/${lan}/attraction`, {
		method: 'GET',
	});

	if (status !== 200) {
		throw new Error(message);
	}

	return { hotelAttraction: data };
});



// WEBPACK FOOTER //
// ./src/actions/attraction.js